import React from 'react';
import { forEach, sortBy } from 'lodash';
import { PIPELINE_CARD_WIDTH, PIPELINE_CARD_SPACING } from '../../constants/pipelineConstants';

class PipelineConnectors extends React.Component {
  constructor(props) {
    super(props);

    this._renderEdges = this._renderEdges.bind(this);
  }

  componentDidMount() {
    this._renderEdges();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.edges !== this.props.edges) {
      this._renderEdges();
    }
  }

  render() {
    const { id } = this.props;

    return <svg id={id} className={'pipeline-connectors'} />;
  }

  _renderEdges() {
    const { id: svgId, edges: unsortedEdges, treeHeight } = this.props;
    const svg = document.getElementById(svgId);

    if (!svg) {
      return;
    }

    const svgWidth = treeHeight * PIPELINE_CARD_WIDTH + (treeHeight - 1) * PIPELINE_CARD_SPACING;
    while (svg.lastChild) {
      svg.removeChild(svg.lastChild);
    }
    const parentMeasure = this._getPosition(svg.parentNode);
    svg.setAttribute('width', svgWidth);
    svg.setAttribute('height', parentMeasure.height);
    svg.setAttribute('viewbox', '0 0 ' + svgWidth + ' ' + parentMeasure.height);
    const edges = sortBy(unsortedEdges, (e) => (e.selected ? 1 : 0));
    const selectedEdgeExists = edges.length > 0 && edges[edges.length - 1].selected;

    const defs = document.createElementNS('http://www.w3.org/2000/svg', 'defs');

    const markerSelected = document.createElementNS('http://www.w3.org/2000/svg', 'marker');

    const markerNotSelected = document.createElementNS('http://www.w3.org/2000/svg', 'marker');
    forEach([markerSelected, markerNotSelected], (marker, id) => {
      const arrowPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');

      let isSelected = id === 0;
      let markerIdName = isSelected ? 'flow-direction-selected' : 'flow-direction-not-selected';
      let markerClassName = isSelected ? 'flow-arrow-selected' : 'flow-arrow-not-selected';
      marker.setAttribute('id', markerIdName);
      marker.setAttribute('markerWidth', 4);
      marker.setAttribute('markerHeight', 4);
      marker.setAttribute('refX', 3.2);
      marker.setAttribute('refY', 2);
      arrowPath.setAttribute('class', markerClassName);
      arrowPath.setAttribute('fill', isSelected ? '#357bff' : '#a8c6ff');
      arrowPath.setAttribute('d', 'M0,0 V4 L4,2 Z');
      marker.appendChild(arrowPath);
      defs.appendChild(marker);
    });
    svg.appendChild(defs);

    forEach(edges, (e) => {
      const connectorFrom = svg.parentNode.querySelector(
        `.pipe-item-${e.from} .pipe-connector-right`,
      );
      const connectorTo = svg.parentNode.querySelector(`.pipe-item-${e.to} .pipe-connector-left`);
      if (connectorFrom && connectorTo) {
        const rectFrom = this._getPosition(connectorFrom, svg.parentNode);
        const rectTo = this._getPosition(connectorTo, svg.parentNode);
        const sF =
          Math.floor(rectFrom.left + rectFrom.width / 2) +
          ',' +
          Math.floor(rectFrom.top + rectFrom.height / 2);
        const dx = rectTo.left - rectFrom.left - 33;
        const dy = rectTo.top - rectFrom.top;
        const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        path.setAttribute('class', 'flow-line');
        path.setAttribute('d', `M ${sF} h 30 v ${dy} h ${dx}`);
        const styles = [];
        if (selectedEdgeExists && !e.selected) {
          styles.push('stroke: #a8c6ff;');
          path.setAttribute('marker-end', 'url(#flow-direction-not-selected)');
        } else {
          path.setAttribute('marker-end', 'url(#flow-direction-selected)');
        }
        if (e.external) {
          styles.push('stroke-dasharray: 10px;');
        }
        if (styles.length) {
          path.setAttribute('style', styles.join(''));
        }
        svg.appendChild(path);
        if (e.transform) {
          const img = document.createElementNS('http://www.w3.org/2000/svg', 'image');
          img.setAttributeNS(
            'http://www.w3.org/1999/xlink',
            'href',
            'https://cdn.nexla.io/ui/static/icons/transform-icon.png',
          );
          img.setAttributeNS(null, 'width', 30);
          img.setAttributeNS(null, 'height', 20);
          img.setAttributeNS(null, 'x', rectTo.left - 40);
          img.setAttributeNS(null, 'y', rectTo.top);
          svg.appendChild(img);
        }
      }
    });
  }

  _getPosition(currentElement, parent) {
    let top = currentElement.offsetTop,
      left = currentElement.offsetLeft;
    if (parent) {
      let actual = currentElement.offsetParent;
      while (actual && actual !== parent) {
        top += actual.offsetTop;
        left += actual.offsetLeft;
        actual = actual.offsetParent;
      }
    }
    return {
      top,
      left,
      width: currentElement.offsetWidth,
      height: currentElement.offsetHeight,
    };
  }
}

export default PipelineConnectors;
